import { apiFetch } from '../http';

export const devicesApi = {
  register: (push_token: string) =>
    apiFetch<{ data: { id: number } }>('/api/v1/devices', { method: 'POST', body: { push_token, platform: 'web' } }),
  remove: (id: number) => apiFetch<void>(`/api/v1/devices/${id}`, { method: 'DELETE' }),
};
